module.exports = __webpack_public_path__ + "img/jumia.62c3e84e.png";